import type { Dict } from './en';

// Deutsche Ressourcen. Gleiche Baumform wie en.ts (TypeScript erzwingt das via Dict).
// Echte UTF-8-Umlaute, natürliches Fachdeutsch (keine KI-Floskeln, keine Antithese).
export const de: Dict = {
  app: {
    title: 'blackfortflow',
    tagline: 'Anlagenmodellierung, Signalgraphen und Live-Monitoring',
  },
  nav: {
    site: 'Standort',
    plant: 'Anlagenschema',
    graph: 'Signalgraph',
    monitor: 'Monitor',
    dashboard: 'Anlagenüberwachung',
    training: 'Training',
    data: 'Daten',
    history: 'Historie',
    audit: 'Audit',
    registrations: 'Freigaben',
    settings: 'Einstellungen',
  },
  site: {
    keinProjekt: 'Kein Projekt gewählt',
    keinProjektHinweis: 'Wähle oben ein Projekt, um seinen Standort zu sehen.',
    keinStandort: 'Für dieses Projekt ist kein Standort hinterlegt',
    keinStandortHinweis:
      'Die Standortansicht braucht einen Mittelpunkt und eine Kartenquelle. Referenz-Anlagen ohne realen Ort bleiben bewusst ohne Standort.',
    standortAnlegen: 'Standort anlegen',
    karteFehlt: 'Die Karte ist in dieser Installation nicht enthalten',
    stand: '{verortet} von {gesamt} Anlagenteilen verortet',
    offen: 'offen',
    bearbeitenAn: 'Verorten',
    bearbeitenAus: 'Verorten beenden',
    speichern: 'Speichern',
    gespeichert: 'Verortung gespeichert.',
    speichernFehler: 'Die Verortung konnte nicht gespeichert werden.',
    erstWaehlen: 'Wähle links ein Anlagenteil, dann ein Werkzeug.',
    werkzeugHinweis: 'Werkzeug wählen, dann in die Karte klicken.',
    werkzeugSetzen: 'Marke setzen',
    werkzeugUmriss: 'Umriss zeichnen',
    werkzeugTrasse: 'Trasse zeichnen',
    punkteGesetzt: '{anzahl} Punkte',
    zeichnungFertig: 'Übernehmen',
    koerper: 'Körperform',
    koerperZylinder: 'Zylinder (rundes Becken, Behälter)',
    koerperQuader: 'Quader (rechteckiges Becken, Gebäude)',
    koerperMarke: 'Marke ohne Volumen',
    hoehe: 'Bauhöhe in Metern',
    groesse: 'Größe in Metern',
    umrissLoeschen: 'Umriss löschen',
    verortungLoesen: 'Verortung lösen',
  },
  common: {
    loading: 'Wird geladen…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    create: 'Anlegen',
    noProject: 'Kein Projekt gewählt',
    noProjectHint: 'Wähle oben ein Projekt oder lege ein neues an, um zu beginnen.',
  },
  header: {
    language: 'Sprache',
  },
  user: {
    signedInAs: 'Angemeldet als {name}',
    logout: 'Abmelden',
  },
  status: {
    project: 'Projekt: {name}',
    noProject: 'Kein aktives Projekt',
    catalog: '{count} Katalog-Variablen',
    graph: '{count} Graph-Knoten',
  },
  domain: {
    biogas: 'Biogas',
    abwasser: 'Abwasser',
    mhkw: 'Müllheizkraftwerk',
    brauerei: 'Brauerei',
    molkerei: 'Molkerei',
    baeder: 'Bäder / Thermen',
    fernwaerme: 'Fernwärme',
    wasserwerk: 'Wasserwerk',
    oberflaeche: 'Oberflächentechnik',
  },
  project: {
    label: 'Projekt',
    none: '— keins —',
    new: 'Neu',
    newTitle: 'Projekt anlegen',
    name: 'Name',
    namePlaceholder: 'z. B. Biogas Nord',
    domain: 'Domäne',
    idPreview: 'ID',
    created: 'Projekt „{name}" angelegt.',
    createFailed: 'Projekt konnte nicht angelegt werden.',
    listFailed: 'Projektliste konnte nicht geladen werden.',
    loadFailed: 'Projektdaten konnten nicht geladen werden.',
  },
  plant: {
    palette: 'Symbole',
    domain: 'Domäne',
    allDomains: 'Alle Domänen',
    search: 'Symbole durchsuchen…',
    searchEmpty: 'Kein Symbol passt zur Suche.',
    category: {
      behaelter: 'Behälter',
      maschine: 'Maschinen',
      sensor: 'Sensoren',
      aktor_sollwert: 'Aktoren / Sollwerte',
      strom: 'Ströme',
    },
    paletteEmpty: 'Keine Symbole für diese Domäne.',
    paletteFailed: 'Symbolpalette konnte nicht geladen werden.',
    canvasEmpty: 'Leeres Anlagenschema',
    canvasHint: 'Wähle ein Symbol aus der Palette, um es auf der Canvas zu platzieren.',
    properties: 'Eigenschaften',
    selectNode: 'Keine Komponente gewählt',
    selectNodeHint: 'Wähle auf der Canvas einen Sensor, um seine Variablen zu pflegen.',
    noVariables: 'Diese Komponente führt keine Katalog-Variablen.',
    saveCatalog: 'Katalog speichern',
    saveSchematic: 'Schema & Katalog speichern',
    saved: 'Schema & Katalog gespeichert (rev {rev}).',
    saveFailed: 'Schema/Katalog konnte nicht gespeichert werden.',
    removeNode: 'Komponente entfernen',
    tag: 'Tag',
    unit: 'Einheit',
    direction: 'Richtung',
    input: 'Eingang (Sensor)',
    output: 'Ausgang (Sollwert)',
    rangeMin: 'Bereich min',
    rangeMax: 'Bereich max',
    opcNode: 'OPC-Node-ID',
    opcType: 'OPC-Datentyp',
    opcNamespace: 'OPC-Namespace-URI',
    opcAccess: 'OPC-Zugriffsart',
    opcQuality: 'OPC-Qualitäts-Handling',
    opcUnset: '(nicht gesetzt)',
    opcAccessRead: 'Lesen',
    opcAccessWrite: 'Schreiben',
    opcAccessReadWrite: 'Lesen + Schreiben',
    opcQualityGate: 'Sperren (gate)',
    opcQualityPassthrough: 'Durchreichen (passthrough)',
    opcQualityHoldLast: 'Letzten Wert halten (hold_last)',
    stampDefaults: 'Regelmuster einsetzen',
    stampHint: 'Vorschlag: vorverdrahtete Mess-Konditionierung / Regelschleife für diese Komponente. Regelschleifen starten in Hand (beobachtend).',
    stamped: 'Regelmuster eingesetzt: {added} Knoten in den Signalgraphen ergänzt ({skipped} bereits vorhanden).',
    stampNothing: 'Regelmuster bereits vorhanden — nichts ergänzt (idempotent).',
    stampFailed: 'Regelmuster konnte nicht eingesetzt werden.',
    stampNoVars: 'Diese Komponente führt keine Katalog-Variablen zum Stempeln.',
    onboardingWizardOpen: 'Onboarding-Wizard',
    uaBrowseOpen: 'OPC-UA-Server browsen (Onboarding)',
    uaBrowse: {
      title: 'UA-Browse-Onboarding',
      intro:
        'Browse einen OPC-UA-Server read-only und übernimm die gefundenen Knoten als Signalkatalog-Entwurf — mit OPC-Bindung. Jeder Kandidat ist ein Vorschlag; du bestätigst oder verwirfst ihn, bevor er produktiv wird.',
      endpoint: 'OPC-UA-Endpunkt',
      readOnlyNote:
        'Read-only, kein blinder Scan: es wird ab dem Objects-Ordner gebrowst und nichts an die Anlage geschrieben.',
      browse: 'Server browsen',
      browsing: 'Browse läuft…',
      candidates: 'Gefundene Tag-Kandidaten',
      confirmedCount: '{confirmed} von {total} bestätigt',
      confirmTag: 'Tag „{tag}" bestätigen',
      confidence: 'Erkennungskonfidenz',
      empty: 'Der Server lieferte keine Variablen-Knoten — Endpunkt/Berechtigungen prüfen.',
      openPoints: 'Im Review noch zu setzen',
      confirm: '{confirmed} Tag(s) übernehmen',
      saving: 'Speichere…',
      saved: 'Signalkatalog geschrieben (rev {rev}).',
      cancel: 'Abbrechen',
    },
  },
  signal: {
    catalogNodes: 'Katalog & Modell',
    blocks: 'Blocktypen',
    superblocks: 'Superblöcke',
    superblockNotRunnable: 'nicht lauffähig (enthält noch nicht abgebildete Blöcke)',
    superblockInner: 'Superblock',
    superblockInnerFailed: 'Innerer Graph konnte nicht geladen werden.',
    superblockRoot: 'Hauptgraph',
    superblockBack: 'Zurück',
    superblockDrillHint: 'Doppelklick öffnet den inneren Graphen von „{name}".',
    importSuperblockButton: 'Superblock importieren (.SBL)',
    importSuperblockBusy: 'Importiere…',
    importSuperblockGroup: 'Importiert',
    importSuperblockRemove: 'Importierten Superblock entfernen',
    importSuperblockDone: '{imported} Superblock/Superblöcke importiert.',
    importSuperblockPartial: '{imported} importiert, {skipped} übersprungen: {reasons}',
    importSuperblockNone: 'Keine Datei importiert — {reasons}',
    importSuperblockFailed: 'Der Superblock-Import ist fehlgeschlagen.',
    importSuperblockRemoved: 'Importierter Superblock „{ref}" entfernt.',
    importSuperblockRemoveFailed: 'Der Superblock konnte nicht entfernt werden.',
    unknownSuperblocks: 'Unbekannte Superblöcke',
    unknownSuperblocksHint:
      'Dieser Graph referenziert {count} Superblock/Superblöcke, die nicht in der Bibliothek liegen. Lade die fehlenden .SBL im Massenimport nach.',
    bulkImportOpen: 'Fehlende Superblöcke massenweise importieren',
    bulkImport: {
      title: 'Superblöcke massenweise importieren (.SBL)',
      intro:
        'Wähle die .SBL-Dateien. Verschachtelte Superblöcke lösen sich über mehrere Durchläufe auf — nach jedem Import siehst du, was noch fehlt.',
      progress: '{resolved} von {total} aufgelöst',
      stillMissing: 'Noch fehlend',
      allResolved: 'Alle referenzierten Superblöcke sind aufgelöst.',
      skipped: 'Übersprungen',
      select: '.SBL-Dateien wählen',
      selectMore: 'Weitere .SBL-Dateien hinzufügen',
      busy: 'Importiere…',
      later: 'Später',
    },
    search: 'Blöcke/Superblöcke durchsuchen…',
    searchEmpty: 'Kein Block passt zur Suche.',
    palette: 'Bausteine',
    paletteFailed: 'Blockpalette konnte nicht geladen werden.',
    canvasEmpty: 'Leerer Signalgraph',
    canvasHint: 'Katalog-Knoten oder Blocktypen hinzufügen und die Ports verdrahten.',
    properties: 'Eigenschaften',
    selectNode: 'Kein Knoten gewählt',
    selectNodeHint: 'Wähle auf der Canvas einen Knoten, um seine Parameter zu bearbeiten.',
    save: 'Graph speichern',
    saved: 'Graph gespeichert (rev {rev}).',
    saveFailed: 'Graph konnte nicht gespeichert werden.',
    validate: 'Validieren',
    valid: 'Graph ist gültig.',
    invalid: 'Graph hat Befunde — siehe Liste.',
    validateFailed: 'Graph konnte nicht validiert werden.',
    findings: 'Befunde',
    tag: 'Katalog-Tag',
    chooseTag: '— Tag wählen —',
    filterFromCatalog:
      'Art und Zeitkonstante der Glättung stehen am Signal im Signalkatalog — dort ändern, damit sie in jedem Graphen gleich gilt. Für eine nur hier geltende Glättung den PT1-Block nehmen.',
    model: 'Modell',
    chooseModel: '— Modell wählen —',
    modelVersion: 'Version',
    chooseVersion: '— Version wählen —',
    noModels: 'Noch keine Modelle in der Registry.',
    modelsFailed: 'Modell-Registry konnte nicht geladen werden.',
    params: 'Parameter',
    noParams: 'Noch keine Parameter.',
    newParam: 'Neuer Parameter',
    removeNode: 'Knoten entfernen',
      kind: {
        input: 'Messwerte',
        output: 'Stellwerte',
        setpoint: 'Sollwerte',
        disturbance: 'Störgrößen',
        exogenous: 'Exogene Größen (Vorhersage)',
        health: 'Zustandssignale',
      },
    node: {
      'catalog-input': 'Katalog-Eingang',
      'catalog-output': 'Katalog-Ausgang',
      'signal-filter': 'Messwert-Glättung',
      'mpc-optimizer': 'MPC-Optimierer',
      'model-inference': 'Modell-Inferenz',
    },
  },
  boris: {
    button: 'BORIS importieren',
    title: 'BORIS-Systemdatei importieren',
    intro:
      'Lade eine BORIS-Systemdatei (.BSY) samt referenzierter Superblöcke (.SBL) hoch. Daraus '
      + 'entstehen ein Signalgraph und ein Signalkatalog; offene Eingangsterminals werden zu '
      + 'Katalog-Eingängen, interne Quellen bleiben erhalten. Die Instanz läuft, sobald der '
      + 'Rechenpfad vollständig ist.',
    files: 'Dateien',
    chooseBsy: '.BSY wählen',
    noBsy: 'keine .BSY gewählt',
    chooseSbl: '.SBL hinzufügen',
    noSbl: 'keine .SBL',
    sblCount: '{count} Superblock-Datei(en)',
    target: 'Ziel',
    targetNew: 'Neues Projekt anlegen',
    newName: 'Projektname',
    newNamePlaceholder: 'z. B. HRT Import',
    targetCurrent: 'In aktuelles Projekt ({project})',
    targetCurrentNone: 'In aktuelles Projekt (keins geöffnet)',
    import: 'Importieren',
    importing: 'Importiere…',
    importFailed: 'Der BORIS-Import ist fehlgeschlagen.',
    runnable: 'Rechenpfad vollständig — die Instanz ist lauffähig.',
    notRunnable:
      'Rechenpfad unvollständig — nicht abgebildete Blöcke oder ungelöste Superblöcke bleiben '
      + 'als Platzhalter. Ergänze die fehlenden Teile, um sie lauffähig zu machen.',
    supported: 'importiert',
    unsupported: 'Platzhalter',
    unresolved: 'ungelöste SB',
    placeholders: 'Nicht abgebildete Blöcke (Platzhalter)',
    unresolvedSuperblocks: 'Ungelöste Superblöcke',
    importedInto: 'Importiert in Projekt „{project}".',
    done: 'Fertig',
    notifyRunnable: 'BORIS-System nach „{project}" importiert — lauffähig.',
    notifyPartial: 'BORIS-System nach „{project}" importiert — mit Platzhaltern (siehe Bericht).',
  },
  modbusMap: {
    button: 'Modbus-Register-Map importieren',
    title: 'Modbus-Register-Map importieren',
    intro:
      'Register-Maps sind oft undokumentiert. Lade die Map des Betreibers/Herstellers (CSV/Tabelle) '
      + 'hoch, statt zu raten oder die Anlage abzutasten. Jede Zeile wird zu einem niedrig-'
      + 'konfidenten Register→Tag-Vorschlag, den du unten bestätigst oder verwirfst. Die Zuordnung '
      + 'ist rein lesend — kein Schreibpfad, keine Adressraum-Abtastung, kein Paket an die Anlage.',
    choose: 'CSV-/Tabellen-Datei wählen',
    chooseAnother: 'Andere Datei wählen',
    importing: 'Map wird gelesen…',
    importFailed: 'Die Register-Map konnte nicht gelesen werden.',
    noProposals: 'Die Map ergab keine Zeilen.',
    disclaimerTitle: 'Rein lesender Import — kein Scan',
    tableCaption: 'Register-→-Tag-Vorschläge',
    colDecision: 'Übernehmen',
    colTag: 'Tag',
    colRegister: 'Register',
    colDatatype: 'Datentyp',
    colWordOrder: 'Wortreihenfolge',
    colScaling: 'Skalierung',
    colUnit: 'Einheit',
    colConfidence: 'Konfidenz',
    colIssues: 'Hinweise',
    confirm: 'Zuordnung bestätigen',
    confirmBusy: 'Wird geschrieben…',
    confirmFailed: 'Die Zuordnung konnte nicht angewendet werden.',
    confirmed: 'Zuordnung bestätigt — {count} Tag(s) geschrieben (Rev {rev}).',
    incompleteHint: 'Jede Zeile muss bestätigt oder verworfen werden, bevor geschrieben wird.',
    notBindable: 'nicht bindbar',
    selectAll: 'Alle übernehmen',
    discardAll: 'Alle verwerfen',
    reviewNote: 'Jede Zeile muss geprüft werden — nichts geht ungeprüft produktiv.',
    close: 'Schließen',
    cancel: 'Abbrechen',
    editTag: 'Tag bearbeiten',
  },
  onboardingWizard: {
    title: 'Onboarding-Wizard',
    stepName: {
      tier: 'Verfahren',
      discovery: 'Discovery',
      review: 'Vorschlag & Bestätigung',
      authorize: 'Freigabe',
    },
    tierIntro:
      'Geführtes Onboarding: wähle das Anbindungsverfahren. In beiden Fällen wird nichts an die Anlage geschrieben — Discovery ist gefragt und read-only, jeder Kandidat ist ein Vorschlag, und erst mit erfasster schriftlicher Freigabe wird der Katalog geschrieben.',
    tierA: 'Tier A — OPC UA',
    tierADesc: 'Einen OPC-UA-Server read-only browsen und Tag-Kandidaten mit OPC-Bindung vorschlagen.',
    tierB: 'Tier B — Modbus',
    tierBDesc: 'Eine Register-Map (CSV/Hersteller-Tabelle) importieren und Register→Tag vorschlagen.',
    endpoint: 'OPC-UA-Endpunkt',
    readOnlyNoteA:
      'Read-only, kein blinder Scan: es wird ab dem Objects-Ordner gebrowst und nichts an die Anlage geschrieben.',
    readOnlyNoteB:
      'Import statt Sweep: die Register-Map wird eingelesen — kein Adressraum-Scan, kein Paket an die Anlage.',
    browse: 'Server browsen',
    discovering: 'Discovery läuft…',
    chooseFile: 'Register-Map wählen',
    importing: 'Import läuft…',
    candidates: 'Gefundene Kandidaten',
    confirmedCount: '{confirmed} von {total} bestätigt',
    confirmTag: 'Kandidat „{tag}" bestätigen',
    confidence: 'Erkennungskonfidenz',
    notBindable: 'nicht bindbar',
    empty: 'Keine Kandidaten gefunden — Endpunkt/Berechtigungen bzw. die Register-Map prüfen.',
    toAuthorize: 'Weiter zur Freigabe ({confirmed} übernehmen)',
    authorizeIntro:
      'Erfasse die schriftliche Freigabe. Sie wird revisionssicher in den Audit-Trail geschrieben und an die geschriebene Katalog-Revision gebunden.',
    authorizeSummary: 'Verfahren: {tier} · {confirmed} Kandidat(en) übernehmen.',
    grantedBy: 'Freigegeben durch',
    grantedByPlaceholder: 'Name/Kennung des Freigebenden',
    grantedAt: 'Zeitpunkt der Freigabe',
    scope: 'Umfang (optional)',
    scopePlaceholder: 'z. B. „Onboarding Belebungsbecken, 12 Tags"',
    back: 'Zurück',
    confirmAndWrite: 'Freigeben & Katalog schreiben',
    saving: 'Speichere…',
    saved: 'Signalkatalog geschrieben (rev {rev}).',
    auditNote: 'Die Freigabe wurde revisionssicher im Audit-Trail protokolliert.',
    cancel: 'Abbrechen',
  },
  monitor: {
    start: 'Lauf starten',
    startLive: 'Live starten',
    stop: 'Lauf stoppen',
    started: 'Lauf {run} gestartet.',
    startFailed: 'Lauf konnte nicht gestartet werden.',
    stopped: 'Lauf gestoppt.',
    modeSim: 'Simulation',
    modeLive: 'Live (OPC-Demonstrator)',
    mode: {
      label: 'Lauf-Modus',
    },
    live: {
      endpoint: 'OPC-Endpoint',
      noEndpoint: 'OPC-Endpoint in den Einstellungen setzen, um live zu fahren.',
      started: 'Live-Lauf {run} gestartet.',
      failed: 'Live-Lauf konnte nicht gestartet werden.',
    },
    stopFailed: 'Lauf konnte nicht gestoppt werden.',
    attached: 'Live-Lauf aktiv (nur Mitlesen)',
    reconnect: 'Neu verbinden',
    lost: 'Verbindung verloren.',
    trend: 'Trend',
    xy: 'XY-Plot',
    chart: {
      trend: 'Trend',
      xy: 'XY',
    },
    values: 'Werte',
    noData: 'Noch keine Live-Daten',
    noDataHint: 'Starte einen Lauf, um Tick-Werte über den WebSocket zu streamen.',
    noValues: 'Noch keine Werte.',
    paceFailed: 'Geschwindigkeit konnte nicht verstellt werden.',
    speed: {
      heading: 'Geschwindigkeit',
      cycle: 'Zykluszeit',
      factor: 'Zeitraffer',
      realtime: 'Echtzeit',
      locked: 'Live-OPC: Echtzeit (1×), Zeitraffer gesperrt',
    },
    view: {
      window: 'Zeitfenster',
      all: 'Alles',
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
      reset: 'Zurücksetzen',
      follow: 'Neuestem folgen',
    },
    conn: {
      idle: 'Bereit',
      connecting: 'Verbinde…',
      live: 'Live',
      lost: 'Verloren',
    },
    csv: {
      source: 'Quelle',
      sim: 'Simulation',
      replay: 'Aus CSV (Replay)',
      chooseSource: '— Datenquelle wählen —',
      noSources: 'Noch keine Datenquellen — in der Daten-Ansicht anlegen.',
      endBehavior: 'Am Dateiende',
      loopCount: 'Wiederholungen (0 = unbegrenzt)',
      loopGap: 'Pause zwischen Durchläufen (s)',
      end: {
        stop: 'Anhalten',
        loop: 'Loop',
        hold: 'Letzten Wert halten',
      },
    },
  },
  training: {
    heading: 'Trainings-Umgebung',
    intro:
      'In den Notebooks trainierst du Soft-Sensoren, exportierst sie nach ONNX, veröffentlichst sie in die Modell-Registry und nutzt sie als model-inference-Baustein im Signalgraph.',
    chain: 'Notebook → Training → ONNX + Manifest → Registry → Baustein im Signalgraph.',
    openRegistry: 'Modell-Registry öffnen',
    goals: {
      heading: 'Optimierungsziele fürs Training',
      intro:
        'Welche Ziele des MPC-Optimierers das Training verfolgen soll — und warum. Die wählbaren Ziele stammen aus den mpc-optimizer-Knoten des Signalgraphen; Auswahl und Begründung gehören zum Anlagenmodell und sind git-versioniert.',
      auswahl: 'Ziele',
      begruendung: 'Begründung der Zielwahl',
      begruendungHinweis:
        'Wer in zwei Jahren fragt, warum die Biologie schwerer wog als der Ertrag, findet die Antwort hier statt in einer Besprechungsnotiz.',
      speichern: 'Zielparameter speichern',
      trainingStarten: 'Training starten',
      notebookGenerieren: 'Notebook generieren',
      notebookAusfuehren: 'Erzeugtes Notebook ausführen',
      erzeugt: 'Notebook erzeugt mit {model}. Bitte den Code lesen, bevor er läuft.',
      vorschauHinweis: 'Erzeugt mit {model}, abgelegt als Snapshot {sha}… — erzeugter Code ist kein geprüfter Code.',
      laufOk: 'Lauf erfolgreich.',
      laufFehler: 'Lauf fehlgeschlagen.',
      gespeichert: 'Zielparameter gespeichert.',
      gestartet: 'Trainingslauf {id} gestartet.',
      ungespeichert: 'Ungespeicherte Änderungen — erst speichern, dann starten.',
      begruendungPflicht: 'Ziele gewählt, aber nicht begründet — die Begründung ist bei einem Trainingslauf Pflicht.',
      laden: 'Zielparameter werden geladen …',
      keineZiele:
        'Dieser Anlagengraph trägt keinen mpc-optimizer-Knoten. Es gibt daher nichts zu wählen — der Knoten wird im Signalgraph ergänzt.',
      einklappen: 'Einklappen',
      ausklappen: 'Ausklappen',
      gewicht: 'Gewicht',
      art: {
        setpoint: 'Sollwert {wert} halten',
        min: 'minimieren',
        max: 'maximieren',
      },
    },
    loading: 'Trainings-Umgebung wird geprüft…',
    unavailableTitle: 'Trainings-Umgebung nicht gestartet',
    unavailableHint:
      'Das eingebettete JupyterLab ist nicht erreichbar. Starte es wie in der Betriebsdoku beschrieben (demo/klaeranlage) und lade diese Ansicht neu.',
    disabledTitle: 'Trainings-Umgebung deaktiviert',
    disabledHint:
      'Diese Installation bietet die eingebettete Trainings-Umgebung nicht an. Aktiviere sie über BFF_TRAINING_ENABLED in der Backend-Konfiguration.',
    frameTitle: 'JupyterLab-Trainings-Umgebung',
    openInTab: 'In neuem Tab öffnen',
    pod: {
      label: 'GPU-/Trainings-Pod',
      local: 'Lokal (CPU)',
      active: 'aktiv',
      inactive: 'aus',
      provider: 'Provider',
      account: 'Konto',
      gpu: 'GPU',
      region: 'Region',
      cloudType: 'Cloud-Art',
      noneChosen: '— keine Angabe —',
      secrets: 'Zugangsdaten hinterlegt',
      noSecrets: 'keine Zugangsdaten',
      none: 'Kein GPU-Pod konfiguriert (lokaler CPU-Pfad).',
      configure: 'GPU-Pod konfigurieren',
      editorTitle: 'Mein GPU-/Trainings-Pod',
      editorHint:
        'Diese Konfiguration gehört dir allein: Provider, GPU und Kosten laufen auf dein Konto. Sie gilt für deine Trainingsläufe, nicht für die der anderen.',
      owner: 'Besitzer',
      enabledLabel: 'Pod nutzen',
      gpuType: 'GPU-Typ',
      gpuCount: 'GPU-Anzahl',
      cpuCores: 'CPU-Kerne (max.)',
      memoryGb: 'Arbeitsspeicher GB (max.)',
      maxRuntimeMin: 'Laufzeit Minuten (max.)',
      maxCostEur: 'Kostendeckel EUR',
      apiKeyHandle: 'Zugangsdaten (OpenBao-Handle)',
      apiKeyHint:
        'Nur der Verweis, nie der Schlüssel: bao:<pfad>#<feld>. Der Wert wird erst beim Start eines Pods aus OpenBao gelesen.',
      handleInvalid:
        'Das ist kein OpenBao-Handle. Erwartet wird bao:<pfad>#<feld> — ein Schlüssel im Klartext gehört hier nicht hinein.',
      save: 'Speichern',
      saving: 'Wird gespeichert…',
      saved: 'Gespeichert.',
      saveFailed: 'Die Pod-Konfiguration konnte nicht gespeichert werden.',
      loadFailed: 'Die Pod-Konfiguration konnte nicht geladen werden.',
      close: 'Schließen',
    },
  },
  registry: {
    title: 'Modell-Registry',
    hint: 'Veröffentlichte Modelle mit ihren Versionen, dem Governance-Status und der aktiven Version. Eine Version wählen, um ihr Manifest (Ein-/Ausgänge, Metriken, Notebook-Hash, Freigabe) zu sehen.',
    reload: 'Neu laden',
    close: 'Schließen',
    loading: 'Registry wird geladen…',
    loadFailed: 'Die Modell-Registry konnte nicht geladen werden.',
    empty: 'Noch keine Modelle',
    emptyHint: 'In den Notebooks ein Modell trainieren, nach ONNX exportieren und in die Registry veröffentlichen — dann erscheint es hier.',
    pickVersion: 'Eine Version wählen, um ihr Manifest zu sehen.',
    manifestLoading: 'Manifest wird geladen…',
    manifestFailed: 'Das Manifest konnte nicht geladen werden.',
    active: 'aktiv',
    currentIs: 'Aktiv: {version}',
    noCurrent: 'Keine aktive Version',
    inputs: 'Eingänge',
    outputs: 'Ausgänge',
    noPorts: 'Keine Ports im Manifest.',
    portName: 'Name',
    portQuantity: 'Größe',
    portUnit: 'Einheit',
    portDtype: 'Typ',
    metrics: 'Metriken',
    notebookHash: 'Notebook-Hash',
    governance: 'Freigabe',
    approvedBy: 'Freigegeben von',
    approvedAt: 'Freigegeben am',
    note: 'Notiz',
    approve: 'Freigeben',
    activate: 'Aktiv schalten',
    approveConfirm: 'Version {version} von „{model}" freigeben (Status → freigegeben)?',
    activateConfirm: 'Version {version} von „{model}" aktiv schalten (wird die genutzte Version)?',
    approved: 'Version {version} von „{model}" freigegeben.',
    activated: 'Version {version} von „{model}" ist jetzt aktiv.',
    approveFailed: 'Die Freigabe ist fehlgeschlagen.',
    activateFailed: 'Das Aktivieren ist fehlgeschlagen.',
    status: {
      draft: 'Entwurf',
      approved: 'Freigegeben',
      active: 'Aktiv',
      retired: 'Ausgemustert',
      deprecated: 'Veraltet',
    },
  },
  dashboard: {
    overview: 'Anlagenüberblick',
    loops: 'Regelschleifen',
    noLoops: 'Keine Aktor-Sollwerte in diesem Katalog.',
    empty: 'Kein Katalog zu überwachen',
    emptyHint: 'Dieses Projekt führt noch keinen Signalkatalog. Sensoren und Sollwerte in der Anlagen-Ansicht anlegen.',
    allNormal: 'Alle Werte im Normbereich',
    alarms: 'Alarme',
    warnings: 'Warnungen',
    setpoint: 'Sollwert',
    clamped: 'Geklemmt',
    rateLimited: 'Ratenbegrenzt',
    state: {
      warn: 'Warnung',
      alarm: 'Alarm',
    },
    mode: {
      auto: 'Auto',
      hand: 'Hand',
      failsafe: 'Fail-safe',
      unknown: 'Unbekannt',
    },
    watchdog: {
      label: 'Watchdog',
      ok: 'OK',
      tripped: 'Ausgelöst',
      unknown: 'Unbekannt',
    },
    display: {
      label: 'Anzeige',
      all: 'Alle',
      perTile: 'Anzeigeart dieser Kachel',
      saveFailed: 'Anzeigeart konnte nicht gespeichert werden.',
      numeric: 'Kachel',
      gauge: 'Tacho',
      trend: 'Graph',
      bar: 'Balken',
      lamp: 'Lampe',
      digital: 'Digital',
      table: 'Tabelle',
    },
    table: {
      tag: 'Tag',
      name: 'Bezeichnung',
      value: 'Wert',
      unit: 'Einheit',
      state: 'Zustand',
    },
    tableState: {
      normal: 'Normal',
      warn: 'Warnung',
      alarm: 'Alarm',
      unknown: 'Unbekannt',
    },
  },
  data: {
    heading: 'Datenquellen',
    intro:
      'Aufgezeichnete CSV-Daten hochladen und ihre Spalten den Katalog-Eingängen zuordnen. Nur die Zuordnung wird mit dem Projekt versioniert — die CSV-Dateien bleiben auf dieser Instanz und werden nicht mit der Appliance ausgeliefert.',
    files: 'CSV-Dateien',
    upload: 'CSV hochladen',
    uploading: 'Wird hochgeladen…',
    uploaded: 'Datei „{name}" hochgeladen.',
    uploadFailed: 'Datei konnte nicht hochgeladen werden.',
    noFiles: 'Noch keine CSV-Dateien. Lade eine hoch, um zu beginnen.',
    remove: 'Entfernen',
    removed: 'Datei entfernt.',
    removeFailed: 'Datei konnte nicht entfernt werden.',
    selectFile: 'Wähle eine Datei, um ihre Spalten und die Zuordnung zu sehen.',
    columns: 'Spalten',
    sample: 'Beispielzeilen',
    timestampColumn: 'Zeitstempel-Spalte',
    noTimestamp: '— keine (eine Zeile pro Tick) —',
    mapping: 'Zuordnung Spalte → Eingang',
    mappingHint:
      'Ordne jede CSV-Spalte einem Katalog-Eingang zu (oder lass sie frei). Die Zeitstempel-Spalte steuert den Takt; zwischen Abtastpunkten wird der Wert gehalten.',
    csvColumn: 'CSV-Spalte',
    catalogInput: 'Katalog-Eingang',
    unassigned: '— nicht zugeordnet —',
    noInputs: 'Dieses Projekt führt keine Katalog-Eingänge. Lege zuerst Sensoren in der Anlagen-Ansicht an.',
    save: 'Zuordnung speichern',
    saved: 'Zuordnung gespeichert (rev {rev}).',
    saveFailed: 'Zuordnung konnte nicht gespeichert werden.',
    loadFailed: 'Datenquellen konnten nicht geladen werden.',
    columnsFailed: 'Spalten dieser Datei konnten nicht gelesen werden.',
    empty: 'Kein Projekt gewählt',
    emptyHint: 'Wähle ein Projekt, um seine CSV-Datenquellen zu verwalten.',
  },
  history: {
    title: 'Änderungshistorie',
    hint: 'Jede Projektänderung ist ein git-Commit. Klick auf eine Zeile lädt ihren Diff; zu jedem Stand lässt sich als neuer Commit zurückrollen.',
    empty: 'Kein Projekt gewählt',
    emptyHint: 'Wähle ein Projekt, um seine Änderungshistorie zu sehen.',
    noCommits: 'Noch keine Commits.',
    loadFailed: 'Die Historie konnte nicht geladen werden.',
    diffFailed: 'Der Diff konnte nicht geladen werden.',
    diffEmpty: 'Keine Text-Änderung für dieses Objekt.',
    objects: 'Geänderte Objekte',
    loadMore: 'Mehr laden',
    revert: 'Zu diesem Stand zurück',
    reverting: 'Rollback läuft…',
    revertConfirm: 'Das Projekt auf Revision {rev} zurücksetzen? Das legt einen neuen Commit an; die Vorwärts-Historie bleibt erhalten.',
    reverted: 'Auf {rev} zurückgesetzt (neue Revision {newRev}).',
    revertFailed: 'Der Rollback ist fehlgeschlagen.',
    author: 'Autor',
  },
  audit: {
    title: 'Audit-Trail',
    hint: 'Die fälschungssichere Ereigniskette dieses Projekts. Das Abzeichen zeigt, ob die Hash-Kette intakt ist.',
    empty: 'Kein Projekt gewählt',
    emptyHint: 'Wähle ein Projekt, um seinen Audit-Trail zu sehen.',
    noEntries: 'Noch keine Audit-Einträge.',
    loadFailed: 'Der Audit-Trail konnte nicht geladen werden.',
    chainOk: 'Kette intakt',
    chainBroken: 'Kette gebrochen bei Seq {seq}',
    length: '{count} Einträge',
    export: 'Audit exportieren',
  },
  login: {
    title: 'blackfortflow',
    subtitlePassword: 'Mit Benutzername und Passwort anmelden.',
    subtitleToken: 'Anmelden — Zugriffs-Token eintragen.',
    username: 'Benutzername',
    password: 'Passwort',
    token: 'Zugriffs-Token',
    submit: 'Anmelden',
    withPassword: 'Anmelden mit Passwort',
    withToken: 'Anmelden mit Token',
    toRegister: 'Konto anlegen',
    forgot: 'Passwort vergessen?',
    failed: 'Anmeldung fehlgeschlagen. Benutzername und Passwort prüfen.',
    error: {
      email_unverified: 'Bitte bestätige zuerst deine E-Mail-Adresse. Der Link steht in deinem Postfach.',
      approval_pending: 'Dein Konto wartet auf die Freigabe durch einen Administrator.',
      account_rejected: 'Deine Registrierung wurde abgelehnt. Wende dich an einen Administrator.',
      account_disabled: 'Dein Konto ist deaktiviert. Wende dich an einen Administrator.',
      account_not_active: 'Dein Konto ist noch nicht freigeschaltet.',
      too_many_attempts: 'Zu viele Anmeldeversuche. Bitte versuche es später erneut.',
    },
  },
  auth: {
    backToLogin: 'Zurück zur Anmeldung',
  },
  mfa: {
    subtitle: 'Zwei-Faktor-Anmeldung',
    hint: 'Gib den 6-stelligen Code aus deiner Authenticator-App ein.',
    recoveryHint: 'Gib einen deiner Recovery-Codes ein.',
    codePlaceholder: '6-stelliger Code',
    recoveryPlaceholder: 'Recovery-Code',
    submit: 'Bestätigen',
    useRecovery: 'Stattdessen einen Recovery-Code verwenden',
    useAuthenticator: 'Stattdessen die Authenticator-App verwenden',
    error: {
      invalid: 'Der Code stimmt nicht. Bitte versuche es erneut.',
      expired: 'Der zweite Schritt ist abgelaufen. Bitte melde dich neu an.',
    },
  },
  register: {
    subtitle: 'Konto anlegen. Du erhältst eine Bestätigungsmail.',
    email: 'E-Mail',
    password: 'Passwort',
    name: 'Anzeigename (optional)',
    submit: 'Registrieren',
    submitted:
      'Registrierung erhalten. Bitte bestätige deine E-Mail-Adresse über den zugesandten Link.',
    conflict: 'Ein Konto mit dieser Kennung oder E-Mail existiert bereits.',
    invalid: 'Bitte eine gültige E-Mail-Adresse und ein Passwort eingeben.',
    disabled: 'Die Selbstregistrierung ist auf dieser Instanz nicht verfügbar.',
    failed: 'Registrierung fehlgeschlagen. Bitte versuche es später erneut.',
  },
  forgot: {
    subtitle: 'E-Mail eintragen, um einen Link zum Zurücksetzen des Passworts zu erhalten.',
    email: 'E-Mail',
    submit: 'Link senden',
    sent: 'Falls zu dieser E-Mail ein Konto existiert, wurde ein Link zum Zurücksetzen gesendet.',
    tooMany: 'Zu viele Anfragen. Bitte versuche es später erneut.',
    failed: 'Der Passwort-Reset konnte nicht angefordert werden. Bitte versuche es später erneut.',
  },
  reset: {
    subtitle: 'Ein neues Passwort für dein Konto setzen.',
    identity: 'Benutzername',
    token: 'Reset-Token',
    newPassword: 'Neues Passwort',
    submit: 'Neues Passwort setzen',
    done: 'Passwort gesetzt. Bitte melde dich mit deinem neuen Passwort an.',
    invalid: 'Der Reset-Link ist ungültig, abgelaufen oder bereits verwendet.',
    failed: 'Das neue Passwort konnte nicht gesetzt werden. Bitte versuche es erneut.',
  },
  verify: {
    subtitle: 'E-Mail-Adresse bestätigen',
    hint: 'Deine E-Mail-Adresse wird bestätigt…',
    checking: 'Wird bestätigt…',
    done: 'E-Mail bestätigt. Dein Konto wartet nun auf die Freigabe durch einen Administrator.',
    failed: 'Der Bestätigungslink ist ungültig oder abgelaufen.',
    missing: 'Der Bestätigungslink ist unvollständig (Token fehlt).',
    resend: 'Bestätigungsmail erneut senden',
    resent: 'Falls ein noch nicht bestätigtes Konto existiert, wurde die Mail erneut gesendet.',
    resendTooMany: 'Zu viele Anfragen. Bitte kurz warten, bevor du es erneut versuchst.',
  },
  registrations: {
    heading: 'Registrierungen freigeben',
    intro: 'Konten, die auf Freigabe warten. Freigeben schaltet die Anmeldung frei; ablehnen ist dauerhaft.',
    rolesLabel: 'Initiale Rollen',
    reason: 'Grund (optional)',
    reasonPlaceholder: 'z. B. kein belegter geschäftlicher Kontext',
    approve: 'Freigeben',
    reject: 'Ablehnen',
    rejectConfirm: 'Ablehnung bestätigen',
    approved: 'Konto „{identity}" freigegeben — der Nutzer kann sich jetzt anmelden.',
    rejected: 'Konto „{identity}" abgelehnt.',
    notPending: 'Dieses Konto wurde bereits entschieden. Die Liste wurde aktualisiert.',
    approveFailed: 'Das Konto konnte nicht freigegeben werden.',
    rejectFailed: 'Das Konto konnte nicht abgelehnt werden.',
    loadFailed: 'Die Freigabe-Warteschlange konnte nicht geladen werden.',
    empty: 'Keine Konten warten auf Freigabe.',
    emptyHint: 'Neue Selbstregistrierungen erscheinen hier, sobald ihre E-Mail bestätigt ist.',
  },
  settings: {
    heading: 'Einstellungen',
    tabUsers: 'Benutzer',
    tabFourEyes: 'Vier-Augen',
    tabLlm: 'LLM',
    tabProfile: 'Mein Profil',
    // ── Projekt-Einstellungen (OPC-Endpoint + Zykluszeit, Issue #121) ──
    opcEndpoint: 'OPC-Endpoint',
    cycleTime: 'Zykluszeit (ms)',
    project: {
      heading: 'Projekt-Einstellungen',
      save: 'Einstellungen speichern',
      saved: 'Projekt-Einstellungen gespeichert.',
      saveFailed: 'Projekt-Einstellungen konnten nicht gespeichert werden.',
      loadFailed: 'Projekt-Einstellungen konnten nicht geladen werden.',
      readOnly: 'Nur lesbar (kein Recht „editieren").',
      notSet: 'nicht gesetzt',
    },
    usersHeading: 'Benutzer-Verwaltung',
    usersIntro: 'Benutzer anlegen, Rollen zuweisen, Passwörter zurücksetzen und Token rotieren.',
    identity: 'Kennung',
    roles: 'Rollen',
    statusColumn: 'Status',
    actions: 'Aktionen',
    active: 'Aktiv',
    disabled: 'Deaktiviert',
    hasPassword: 'Passwort-Login',
    hasToken: 'Token aktiv',
    noUsers: 'Noch keine Benutzer.',
    loadUsersFailed: 'Benutzerliste konnte nicht geladen werden.',
    createHeading: 'Benutzer anlegen',
    createIdentity: 'Kennung',
    createIdentityPlaceholder: 'z. B. m.mueller',
    initialPassword: 'Initialpasswort',
    initialPasswordPlaceholder: 'optional',
    create: 'Benutzer anlegen',
    created: 'Benutzer „{identity}" angelegt.',
    createFailed: 'Benutzer konnte nicht angelegt werden.',
    editRoles: 'Rollen ändern',
    saveRoles: 'Rollen speichern',
    rolesSaved: 'Rollen für „{identity}" aktualisiert.',
    updateFailed: 'Benutzer konnte nicht geändert werden.',
    lastAdmin: 'Dieser Benutzer ist der letzte aktive Admin und kann nicht geändert oder gelöscht werden.',
    resetPassword: 'Passwort zurücksetzen',
    newPassword: 'Neues Passwort',
    setPassword: 'Passwort setzen',
    passwordSet: 'Passwort für „{identity}" gesetzt.',
    setPasswordFailed: 'Passwort konnte nicht gesetzt werden.',
    rotateToken: 'Token rotieren',
    tokenRotated: 'Neues Token für „{identity}" — wird nur einmal angezeigt, jetzt kopieren:',
    rotateFailed: 'Token konnte nicht rotiert werden.',
    copyToken: 'Kopieren',
    tokenCopied: 'Token kopiert.',
    remove: 'Löschen',
    confirmRemove: 'Benutzer „{identity}" wirklich löschen?',
    removed: 'Benutzer „{identity}" gelöscht.',
    removeFailed: 'Benutzer konnte nicht gelöscht werden.',
    profileHeading: 'Mein Profil',
    myIdentity: 'Kennung',
    myRoles: 'Rollen',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    changePasswordButton: 'Passwort ändern',
    passwordChanged: 'Dein Passwort wurde geändert.',
    changePasswordFailed: 'Passwort konnte nicht geändert werden.',
    loadMeFailed: 'Profil konnte nicht geladen werden.',
    // Zwei-Faktor / TOTP (Issue #192)
    mfaHeading: 'Zwei-Faktor-Anmeldung',
    mfaIntro:
      'Sichere dein Konto mit einem zweiten Faktor aus einer Authenticator-App (TOTP). Nach dem Passwort wirst du dann nach einem 6-stelligen Code gefragt.',
    mfaStatusOn: 'Zwei-Faktor ist aktiv.',
    mfaStatusOff: 'Zwei-Faktor ist aus.',
    mfaRecoveryLeft: 'Noch {count} Recovery-Codes übrig.',
    mfaEnable: 'Zwei-Faktor einrichten',
    mfaEnrollHint:
      'Scanne den QR-Code mit deiner Authenticator-App oder gib das Secret manuell ein. Bestätige dann mit dem ersten 6-stelligen Code.',
    mfaSecretLabel: 'Secret (manuelle Eingabe)',
    mfaConfirmCode: 'Code aus der App',
    mfaConfirm: 'Bestätigen und aktivieren',
    mfaEnabledNotice: 'Zwei-Faktor ist jetzt aktiv.',
    mfaRecoveryHeading: 'Recovery-Codes',
    mfaRecoveryIntro:
      'Bewahre diese Codes sicher auf. Jeder gilt einmal und lässt dich anmelden, falls du deinen Authenticator verlierst. Sie werden nur jetzt angezeigt.',
    mfaRecoveryDone: 'Codes gesichert',
    mfaDisable: 'Zwei-Faktor abschalten',
    mfaDisableConfirmPassword: 'Mit dem aktuellen Passwort bestätigen',
    mfaDisabled: 'Zwei-Faktor wurde abgeschaltet.',
    mfaCancel: 'Abbrechen',
    mfaEnrollFailed: 'Die Einrichtung konnte nicht gestartet werden.',
    mfaActivateFailed: 'Der Code stimmt nicht. Bitte versuche es erneut.',
    mfaDisableFailed: 'Zwei-Faktor konnte nicht abgeschaltet werden. Prüfe dein Passwort.',
    mfaLoadFailed: 'Der Zwei-Faktor-Status konnte nicht geladen werden.',
    forbidden: 'Für die Benutzer-Verwaltung sind Admin-Rechte nötig.',
    fourEyesHeading: 'Vier-Augen pro Projekt',
    fourEyesIntro:
      'Standard: aus — eine Person darf vorschlagen und freigeben. Eingeschaltet verlangt eine zweite Person zur Deploy-Freigabe.',
    fourEyesProject: 'Projekt',
    fourEyesColumn: 'Vier-Augen-Prinzip',
    fourEyesOn: 'Ein',
    fourEyesOff: 'Aus',
    fourEyesToggle: 'Vier-Augen-Prinzip für „{project}" umschalten',
    llm: {
      heading: 'LLM-Konfiguration',
      intro:
        'Zugang zum Sprachmodell-Anbieter für den Notebook-Builder. Der Schlüssel wird nie im Klartext gespeichert: entweder als OpenBao-Handle (bao:<pfad>#<feld>) oder serverseitig verschlüsselt. Aufgelöst wird Projekt → Nutzer → Appliance; die erste Ebene mit Schlüssel gewinnt.',
      keineVerschluesselung:
        'Auf diesem Server ist kein Verschlüsselungsschlüssel konfiguriert. Ein hier eingetippter Schlüssel wird abgewiesen — hinterlegen Sie stattdessen einen OpenBao-Handle (bao:<pfad>#<feld>).',
      projektStand: 'Im Projekt hinterlegt',
      keinSchluessel: 'kein Schlüssel',
      artBao: 'OpenBao-Handle',
      artEnc: 'verschlüsselt abgelegt',
      effektiv: 'Wirksam: Modell {model} (aus {modelFrom}), Schlüssel aus {keyFrom}',
      ebene: {
        projekt: 'Projekt',
        nutzer: 'Nutzer',
        server: 'Appliance',
        default: 'Vorgabe',
      },
      schluessel: 'API-Schlüssel (ersetzen)',
      schluesselPlatzhalter: 'Schlüssel oder bao:<pfad>#<feld>',
      modell: 'Modell',
      modellErben: '— von der nächsten Ebene erben —',
      speichern: 'LLM-Konfiguration speichern',
      entfernen: 'Hinterlegten Schlüssel entfernen',
      entfernt: 'Schlüssel entfernt.',
      gespeichert: 'LLM-Konfiguration gespeichert.',
      laden: 'LLM-Konfiguration wird geladen …',
      keinProjekt: 'Der LLM-Zugang gehört zum Projekt. Wählen Sie oben links ein Projekt, um ihn zu konfigurieren.',
    },
    fourEyesNoProjects: 'Noch keine Projekte.',
    fourEyesLoadFailed: 'Projekte konnten nicht geladen werden.',
    fourEyesSaveFailed: 'Vier-Augen-Prinzip konnte nicht geändert werden.',
    role: {
      admin: 'Admin',
      betreiber: 'Betreiber',
      data_scientist: 'Data Scientist',
      deployer: 'Deployer',
      operator: 'Operator',
    },
  },
};
